import { TwoFactorAuthenticationTypes } from "global/enums";
import { ChangeEvent } from "react";
import { getTwoFactorAuthString } from "./TwoFactorAuthHelpers";

type AuthenticatorTypeSelectProps = {
  onTypeChanged: (e: ChangeEvent<HTMLSelectElement>) => void;
  availableAuthenticatorTypes?: TwoFactorAuthenticationTypes[];
  "data-test-id"?: string;
};

const AuthenticatorTypeSelection = (props: AuthenticatorTypeSelectProps) => {
  return (
    <div className="form-group row d-flex justify-content-center">
      <div className="d-flex justify-content-center">Choose authentication type:</div>
      <div className="col-9 col-form-label d-flex justify-content-center">
        {props.availableAuthenticatorTypes ? (
          <select onChange={props.onTypeChanged} data-test-id={props["data-test-id"]}>
            {props.availableAuthenticatorTypes.map((x) => {
              return (
                <option value={x} key={x}>
                  {getTwoFactorAuthString(x as TwoFactorAuthenticationTypes)}
                </option>
              );
            })}
          </select>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default AuthenticatorTypeSelection;
